import MuiIconButton, { IconButtonProps } from "@mui/material/IconButton";

const IconButton: React.FC<IconButtonProps> = MuiIconButton;

export default IconButton;
export type { IconButtonProps };
